import { atom } from 'recoil';

export const isRequestPendingAtom = atom<boolean>({
    key: 'isRequestPending',
    default: false
});
